import React from "react";

const TransformativeSection = () => {
  return (
    <section className="py-10 relative">
      {/* Background with pattern and gradient overlay */}
      <div 
        className="absolute top-0 bottom-0 left-0 right-0"
        style={{
          background: 'linear-gradient(0deg,hsla(0,0%,100%,0),#fff),url(https://cache.marriott.com/aka-fonts/textures/rz/trc-pattern.svg)',
          backgroundRepeat: 'repeat',
          opacity: 0.3
        }}
      ></div>
      
      {/* Content */}
      <div className="relative z-10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Text Content */}
          <div className="space-y-8">
            <h2 
              className="text-gray-900 leading-tight"
              style={{
                fontFamily: 'Caslon540Std, serif',
                fontSize: '40px',
                fontWeight: 'normal'
              }}
            >
              How will a stay leave you? Discover the transformative power of travel when you journey with The Ritz-Carlton.
            </h2>
          </div>

          {/* Flower Image */}
          <div className="relative">
            <div 
              className="rounded-lg overflow-hidden"
              style={{
                width: '363px',
                height: '544.5px'
              }}
            >
              <img
                src="https://customer-assets.emergentagent.com/job_elegant-booking-1/artifacts/ack5hyoa_flower.jpeg"
                alt="Beautiful flower"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default TransformativeSection;